import React from "react";
import { useTranslation } from "react-i18next";

import Tooltip from "components/Tooltip";
import refreshIcon from "../../assets/icons/refresh.svg";
import cn from "clsx";
import "./Buttons.scss";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading?: boolean;
  position?: "left" | "center" | "right";
};

export const RefreshButton: React.FC<Props> = ({
  isLoading,
  position = "left",
  ...props
}) => {
  const { t } = useTranslation();
  const label = t("refreshTable");

  return (
    <Tooltip text={label} position="top">
      <button
        aria-label={label}
        className={cn(
          "refresh-button",
          isLoading && "is-loading",
          position === "center" && "center",
          position === "left" && "left",
          position === "right" && "right",
        )}
        {...props}
      >
        <img src={refreshIcon} alt="" />
      </button>
    </Tooltip>
  );
};
